import _ from 'lodash';

const brochurePayload = {	// This is current brochure and binder object
	brochure: {
		userId: '',
		accountNumber: '',
		brochureName: '',
		customerLogo: '',
		fileURL: '', //This will be param which will use in step 4
		priceLevel: 'NoPrice',
		layout: 'landscape',
		footNote: '',
		hasCoverPage: 'Y',
		/*new brochure change*/
		hasCoverPageWithImage: 'Y',
		selectedFeatureOption:1,
		selectedBrochureCreateOption :1,
/*end brochure change*/
		pages: [
			{pageNumber: 1, sequence: 1, pageTitle: '', selectedTemplateOption : {templateName:"House of Brands Template"},selectedBrochureDividerTemplate : {dividerTemplateName : "None"},products: [], price: ''},
			{pageNumber: 2, sequence: 2, pageTitle: '',selectedTemplateOption : {templateName:"House of Brands Template"},selectedBrochureDividerTemplate : {dividerTemplateName : "None"}, products: [], price: ''},
			{pageNumber: 3, sequence: 3, pageTitle: '',selectedTemplateOption : {templateName:"House of Brands Template"},selectedBrochureDividerTemplate : {dividerTemplateName : "None"}, products: [], price: ''}
		],
		/*end brochure change*/
		customerInfo: {
			name: '',
			email: '',
			address1: '',
			address2: '',
			city: '',
			state: '',
			zipCode: '',
			phone: ''
		},
		salesInfo: {
			name: '',
			email: '',
			address1: '',
			address2: '',
			city: '',
			state: '',
			zipCode: '',
			phone: '',
			additionalInfo: ''
		},
		productInfo: {
			hasProductNum: 'N',
			hasProductSpec: 'N',
			hasWarrantyInfo: 'N',
			hasProductColor: 'N',
			hasColorChoice: 'N',
			hasSubmittalSheet: "N",
			productColors: []
		}
	},
	binders: [],
	selectedCoverPageName : "Cover Page: with Kitchen Appliances Pictures"
};

const initialState = {
	payload: JSON.parse(JSON.stringify(brochurePayload)),
	savedBrochures: null,
	selectedItems: [],
	whichBrochure: 'new',
	otherAddedProducts: [],
	emailSendSuccessDialog: false,
	radioOptions: [{
		label: "I'll enter my own model numbers",
		value: 1,
		id: "enter_my_own_model_numbers",
		checked: true,
	}, {
		label: "Pick models from my list",
		value: 2,
		id: "pick_models_from_my_list",
		checked: false,
	}, {
		label: "Pick models from sales agreement (quote)",
		value: 3,
		id: "pick_models_from_sales_agreement",
		checked: false,
		display: true,
	}, {
		label: "Pick models from a GE Appliances proposal",
		value: 4,
		id: "pick_models_from_a_ge_appliances_proposal",
		checked: false,
		display: true,
	},
	/*new brochure change*/
	{
		label: "Import file with model numbers",
		value: 5,
		id: "pick_models_from_a_proposal",
		checked: false,
		display: true,
	}
],
	
	selectedBrochureCreateOption: 1,
	featureTypes : [
		{label : "Feature Name Only", value:1, checked : true, id:"Feature_Name_Only"},
		{label : "Feature Name + Description", value:2, checked:false, id:"Feature_Name_+_Description"}
	],
	selectedFeatureOption: 1,
	templateOptions : [],
	dividerTemplateOptions : [],
	coverPageTemplateOptions: [],
	/*end brochure change*/
};

export default function brochure(state = initialState, action) {
  	switch (action.type) {
		case 'SAVE_BROCHURE_DETAILS':
			if(action.data && action.data.responseObject) {
				action.data.responseObject = (typeof action.data.responseObject === 'string') ? JSON.parse(action.data.responseObject) : action.data.responseObject;
				action.data.responseObject = _.orderBy(action.data.responseObject, ['createdDate'], ['desc']);
			}
	    	return {...state,
				savedBrochures: action.data
			}
		case 'ADD_EXTRA_PRODUCT':
			var otherAddedProducts = state.otherAddedProducts;
			otherAddedProducts.push({sequence: otherAddedProducts.length+1, productNumber: '', details: null, inValid: null})
			return {...state,
				otherAddedProducts: otherAddedProducts
			}
		case 'SELECT_BROCHURE_CREATE_OPTION':
			const { radioOptions } = state;
			radioOptions.forEach(item => {
				if (item.value === action.data) {
					item.checked = true;
				} else {
					item.checked = false;
				}
			});
			return {...state,
				selectedBrochureCreateOption: action.data,
				radioOptions
			}
		/*new brochure change*/
		case 'SELECT_FEATURE_CREATE_OPTION':
				const { featureTypes } = state;
				featureTypes.forEach(item => {
					if (item.value === +action.data) {
						item.checked = true;
					} else {
						item.checked = false;
					}
				});
				return {...state,
					selectedFeatureOption: action.data,
					featureTypes
				}
		case 'UPDATE_BROCHURE_TEMPLATE_OPTION':
					return {...state,
						templateOptions: action.data.responseObject.brochureTemplates,
						dividerTemplateOptions : action.data.responseObject.brochureDividerTemplates,
						coverPageTemplateOptions : action.data.responseObject.brochureCoverPageTemplate
					}
			/*end brochure change*/
		case 'UPDATE_SELECTED_ITEMS':
			return {...state,
				selectedItems: _.uniqBy(action.data, 'item')
			}
		case 'UPDATE_PAGES':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						pages: action.data
					}
				}
			}
		case 'UPDATE_OTHER_ADDED_PRODUCTS':
			return {...state,
				otherAddedProducts: action.data
			}
		case 'UPDATE_BROCHURE_CUSTOMER_INFO':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						customerInfo: {
							...state.payload.brochure.customerInfo,
							[action.data.name]: action.data.value
						}
					}
				}
			}
		case 'UPDATE_BROCHURE_FOR_MORE_INFO':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						salesInfo: {
							...state.payload.brochure.salesInfo,
							[action.data.name]: action.data.value
						}
					}
				}
			}
		case 'UPDATE_BROCHURE_PRODUCT_INFO':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						productInfo: {
							...state.payload.brochure.productInfo,
							[action.data.name]: action.data.value
						}
					}
				}
			}
		case 'UPDATE_BROCHURE_COVER_PAGE_INFO':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						salesInfo: action.data
					}
				}
			}
		case 'UPDATE_BROCHURE_PARAM':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						[action.data.name]: action.data.value
					}
				}
			}
		case 'UPDATE_BINDER_PARAM':
			let binders = state.payload.binders;
			binders[binders.length-1][action.data.name] = action.data.value;
			return {...state,
				payload: {...state.payload,
					binders: binders
				}
			}
		case 'UPDATE_BROCHURE_PRODUCT_COLOR_INFO':
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						productInfo: {
							...state.payload.brochure.productInfo,
							productColors: action.data
						}
					}
				}
			}
		case 'UPDATE_BINDER_SHIPPING_ADDRESS_PARAM':
			binders = state.payload.binders;
			binders[binders.length-1][action.data.parentObject][action.data.name] = action.data.value;
			return {...state,
				payload: {...state.payload,
					binders: binders
				}
			}
		case 'ADD_NEW_PAGE':
			var pages = state.payload.brochure.pages;
			/*new brochure change*/
			pages.push({pageNumber: (state.payload.brochure.pages.length+1), sequequence: (state.payload.brochure.pages.length+1), pageTitle: '',selectedTemplateOption : {templateName:"House of Brands Template"}, products: [], price: ''});
			/*end brochure change*/
			return {...state,
				payload: {...state.payload,
					brochure: {...state.payload.brochure,
						pages: pages
					}
				}
			}
		case 'LOAD_SELECTED_SAVED_BROCHURE':
			var brochure = null;
			state.savedBrochures.responseObject.map((item, index) => {
				if(item.brochureId === action.data) {
					brochure = item;
				}
				return null;
			});

			//Load previously selected products as well in to selected items
			var selectedItems = []; //state.selectedItems;
			if(!brochure.selectedCoverPageName){
				brochure.selectedCoverPageName = "Cover Page: with Kitchen Appliances Pictures";
			}
			brochure.pages.forEach((item, index) => {
				item.products.forEach((itm, ind) => {
					var isAvail = _.find(selectedItems, ["item", itm.productNumber]);
					if(!isAvail) {
						selectedItems.push({
							item: itm.productNumber,
							itemDescription: itm.productName,
							itemType: 'M',
							packageName: null,
							quantity: 1,
							parentItem: null,
						});
					}
				});
			})

			return {...state,
				payload: {
					binder: [],
					brochure: {
						...brochure,
						existingBrochureName: brochure.brochureName
					}
				},
				whichBrochure: 'existing',
				selectedItems: selectedItems
			};
		case 'RESET_BROCHURE_PAYLOAD':
			let payload = JSON.parse(JSON.stringify(brochurePayload));
			payload.brochure.accountNumber = action.data;
			return {...state,
				payload: payload,
			};
		case 'CREATE_NEW_BINDER_PAYLOAD':
			binders = state.payload.binders?state.payload.binders:[];
			binders.push({
				brochureName: '',
				hasBrochureName: 'N',
				hasCustomerLogo: 'N',
				hasCoverPage: 'N',
				hasDividerPages: 'N',
				dividerPageSets: 0,
				dividerPageName: [],
				hasSpecPages: 'N',
				specPageSets: 1,
				hasWarrantyInfoPages: 'N',
				hasMortgageCalcSheet: 'N',
				hasDownloadBinder: 'N',
				emailAddress: '',
				totalPages: 0
			});
			return {...state,
				payload: {...state.payload,
					binders: binders
				}
			};
		case 'EMAIL_SEND_SUCCESS_DIALOG':
	        return { ...state,
	            emailSendSuccessDialog: action.data
	        }
		case 'RESET_BROCHURE_REDUCERS':
			return initialState;
	  	default:
	    	return state;
  	}
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/brochure.js